import React from 'react'
import styles from './page.module.scss'

const Loader = () => {
	return (
		<div className={styles.componentLoader}>
			<div className={styles.loader}></div>
		</div>
	)
}

export default Loader
